import React, { Component } from "react";
import {
  Table,
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Confirm } from "react-confirm-bootstrap";
import { markQuestion } from "../../services/GameServices";


class QuestionTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShowing: false,
      editObj: {text: "", number: ""},
      deleteDialog: false,
      selected: "Warning",
      colorArray: [],
      url:""
     };
    this.onEdit = this.onEdit.bind(this);
    this.handleEditChange = this.handleEditChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }
  componentDidMount(){
    console.log(window.location.href);
    let current_route = window.location.href;
    this.setState({url:current_route});

  }
  
  componentDidUpdate(prevProps) {
    if (this.props.questions !== prevProps.questions) {
      let cura=this.props.questions;
      console.log("current quisdtions",cura);
      let colorarr=[];
      
      for (var i=0;i<cura.length;i++){
        let quesobj = cura[i];
        console.log(quesobj.status);
        if(quesobj.status === 0){
          colorarr.push('warning');
        }
        else{
          colorarr.push('success');
        }
      }
      this.setState({colorArray:colorarr});
    }
  }
  handleSelection = (i,qid)=>{
    let gid=this.props.gid;
    console.log(gid);
    let list= {...this.state.colorArray};
    let tf=1;
    console.log(i);
    if(list[i] ==="success"){
      list[i]="warning"
      tf=0;
    }
    else{
      list[i]="success";
    }
    //call an api call here with the index to mark as imbalance
    //markQuestion(i)
    this.setState({colorArray:list});
    markQuestion(gid,qid,tf);
  }

  handleEditChange(e, attribute) {
    const target = e.target
    let temp = Object.assign({}, this.state.editObj);
    temp[attribute] = target.value;
    this.setState({editObj: temp});
  }

  handleUpdate(e) {
    this.setState({modalShowing: false});
    this.props.onUpdate (this.state.editObj);
    // this.setState({editObj: null});
  }
  handleDelete(obj) {
    this.props.onDelete(obj);
  }

  onEdit(e) {
    this.setState({ editable: false });
    // this.props.
  }

  render() {
    function Td({ children, to }) {
      const content = <Link to={to}>{children}</Link>;

      return <td>{content}</td>;
    }

    const content =
      !this.props.questions || this.props.questions.length === 0 ? (
        <tr>
          <td>No {this.props.objecttype} added</td>
          {this.props.attributes.map((attribute, index) => (
            <td key={index}>No {this.props.objecttype} added</td>
          ))}
        </tr>
      ) : (
        this.props.questions.map((obj, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            {this.props.attributes.map((attribute, index) => (
              <td key={index}>{obj[attribute]}</td>
            ))}
            {/* <td key={index}>
                  <FormGroup controlId="formBasicText">
                    <FormControl
                      type={(attribute == "text")?"text": "number"}
                      defaultValue={obj[attribute]}
                      min="1"
                      // onChange={() => this.handleChange(attribute, e)}
                    />
                  </FormGroup>
                  </td>
                );
              } */}

            <td>
              
              <Button
                style={{ marginRight: "10px" }}
                bsSize="small"
                bsStyle="default"
                onClick={() =>
                  this.setState({ modalShowing: true, editObj: obj })
                }
              >
                Edit
              </Button>
              <Link to={`/games/${obj.game}/questions/${obj._id}`}>
                <Button
                  style={{ marginRight: "10px" }}
                  bsSize="small"
                  bsStyle="info"
                >
                  VIEW
                </Button>
                </Link>
                
                

                  <Confirm
                show={this.state.deleteDialog}
                onConfirm={() => this.handleDelete(obj)}
                body="Are you sure you want to delete this Question?"
                confirmText="Confirm Delete"
                title="Delete Question"
              >
                

                <Button
                style={{ marginRight: "10px" }}
                bsSize="small"
                bsStyle="danger"
                onClick={() => this.setState({deleteDialog: true})}
              >
                DELETE
              </Button>
              </Confirm>
                  <Button style={{ marginLeft: "10px" }}
                bsSize="small"
                bsStyle={this.state.colorArray[index] || "warning"}
                onClick={()=>this.handleSelection(index,obj._id)}>
                   Imbalance
                  </Button>
            </td>
          </tr>
        ))
      );

    return (
      <div className="content">
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>#</th>
              {this.props.attributes.map((attribute, index) => (
                <th key={index}>{attribute}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{content}</tbody>
        </Table>

        <Modal
          show={this.state.modalShowing}
          onHide={() => this.setState({ modalShowing: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Question</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup controlId="formBasicText">
                <Row>
                  <Col xs={8} md={8}>
                    <ControlLabel>Question's Text</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.editObj.text}
                      placeholder="Enter the text of the question"
                      onChange={(e) => this.handleEditChange(e, "text")}
                    />
                  </Col>
                  <Col xs={4} md={4}>
                    <ControlLabel>Order</ControlLabel>
                    <FormControl
                      type="number"
                      value={this.state.editObj.order}
                      placeholder="Enter the order of the question"
                      onChange={(e) => this.handleEditChange(e, "order")}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleUpdate}> Update</Button>
          </Modal.Footer>
        </Modal>

        {/* <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-sm"
        >
        <Collapse in={this.state.isShowing}>
            <Row>
                <Col xs={12} md={12}>
                    <Alert bsStyle={this.state.alert}>
                        <strong>{this.state.status}</strong> {this.state.message}
                    </Alert>  
                </Col>
            </Row>
        </Collapse>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-sm">Update</Modal.Title>
        </Modal.Header>
          <Modal.Body>
            <form>
                <FormGroup>
                    <Row>
                            {
                                this.props.myparent.props.attributes.map((attribute,key)=>
                                    (
                                    <Col xs={6} md={4} key = {key}>                                        
                                        <ControlLabel>{attribute.toUpperCase()}</ControlLabel>
                                            <FormControl
                                            type="text"
                                            id={attribute}
                                            value={this.state.fields[attribute]}
                                            placeholder={"Enter "+attribute}
                                            onChange={this.handleChange}
                                            />
                                    </Col>
                                    )
                                )
                            }
                            
                    </Row>
                </FormGroup>
			</form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleSubmit}bsStyle="success">SUBMIT</Button>
            <Button bsStyle="danger" onClick={()=>{this.props.onHide();this.setState({fields:{}})}}>CANCEL</Button>
          </Modal.Footer>
        </Modal> */}
      </div>
    );
  }
}

export default QuestionTable;



// WEBPACK FOOTER //
// ./src/components/Table/QuestionTable.jsx